import { Button, Select,Spacer, Text } from '@app/components' // adjust imports to your project
import { useState } from 'react'

const STATES = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VI',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

export default function SelectStateForm({ onSubmit }: { onSubmit: (state: string) => void }) {
  const [state, setState] = useState('')

  const handleSubmit = () => {
    if (!state) return
    onSubmit(state)
  }

  return (
    <>
      <Text>
        We don&apos;t know which U.S. state you&apos;re in. Please select your state below so we can review your account
        and enable access.
      </Text>

      <Spacer />

      <Select
        value={state}
        onChange={(value) => setState(value)}
        style={{
          width: '100%',
          padding: '10px',
          borderRadius: '8px',
          border: '1px solid #ccc',
          fontSize: '16px',
        }}
      >
        <option value="">Select your state</option>

        {STATES.map((abbrev) => (
          <option key={abbrev} value={abbrev}>
            {abbrev}
          </option>
        ))}
      </Select>

      <Spacer />

      <Button disabled={!state} onClick={handleSubmit}>
        Submit
      </Button>
    </>
  )
}
